import type { ReactNode } from 'react'

import cn from 'clsx'
import { Box, type BoxProps } from '@/components/Box/Box'
import type { doisters } from '@/components/inline-avatar-stack/doister-avatars'
import { InlineAvatarStack } from '@/components/inline-avatar-stack/inline-avatar-stack'

import { Text } from '@/components/Text/Text'

import css from './help-center-note.module.css'

export type HelpCenterNoteProps = {
    title?: ReactNode
    avatar?: keyof typeof doisters
    icon?: React.ReactNode
    variant: 'tip' | 'note' | 'warning'
    badge?: ReactNode
} & Omit<BoxProps, 'title'>

export function HelpCenterNote({
    title,
    icon,
    avatar,
    variant = 'note',
    children,
    className,
    badge,
    ...rest
}: HelpCenterNoteProps) {
    return (
        <Box className={cn(css.helpCenterNote, css[variant], className)} {...rest} data-nosnippet>
            {avatar ? (
                <div className={css.side}>
                    <InlineAvatarStack>
                        <InlineAvatarStack.Avatar doister={avatar} size={36} />
                    </InlineAvatarStack>
                </div>
            ) : (
                icon && <div className={css.side}>{icon}</div>
            )}
            <div className={css.main}>
                <Box className={css.header}>
                    {title && <Box className={css.title}>{title}</Box>}
                    {badge && <Box className={css.badge}>{badge}</Box>}
                </Box>
                <Text className={css.content} tag="div">
                    {children}
                </Text>
            </div>
        </Box>
    )
}
